import { render, staticRenderFns } from "./club-teams-drop-down.vue?vue&type=template&id=4640b3fe&scoped=true"
import script from "./club-teams-drop-down.vue?vue&type=script&lang=js"
export * from "./club-teams-drop-down.vue?vue&type=script&lang=js"
import style0 from "./club-teams-drop-down.vue?vue&type=style&index=0&id=4640b3fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640b3fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4640b3fe')) {
      api.createRecord('4640b3fe', component.options)
    } else {
      api.reload('4640b3fe', component.options)
    }
    module.hot.accept("./club-teams-drop-down.vue?vue&type=template&id=4640b3fe&scoped=true", function () {
      api.rerender('4640b3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-teams/club-teams-table/club-teams-drop-down.vue"
export default component.exports